import React from 'react';

import fluidSizesSources from 'Components/Skeleton/fluidSizesSources';
import SkeletonImg, { SLOT_VALUE } from 'Components/Skeleton/SkeletonImg';
import SkeletonBundleLayout from 'Components/Skeleton/SkeletonBundleLayout';

// The cover's FluidImg in BundleDesktopLayout (tiered bundles, lg and up): uncropped
const DESKTOP_MEDIA = '(min-width: 992px)';
const DESKTOP_SIZES = '(min-width: 576px) 524px, calc(100vw - 1rem)';

// The cover's ProductCover in BundleView (below lg, and untiered bundles): cropped to 16:9
const COVER_SIZES = '(min-width: 1520px) 662px, (min-width: 1200px) 562px, (min-width: 991px) 472px, (min-width: 768px) 352px, 98vw';

/**
 * Bundle page while it loads. BundleView shows BundlePageRedesign on lg and up for tiered bundles (most of them),
 * and its own header otherwise; this follows the redesign on lg and up and the header below. The two render the
 * cover with different srcsets, so a <picture> picks the matching one per breakpoint and only one is downloaded.
 * Slots: `name` (text), `cover` (image URL). No background: the page no longer renders the bundle background
 * image (product.header only adds the `background-bundle` class).
 */
export default function BundlePageSkeleton() {
  const cover = (
    <picture>
      <source
        media={DESKTOP_MEDIA}
        sizes={DESKTOP_SIZES}
        data-skeleton-slot="cover"
        data-slot-srcset={fluidSizesSources(DESKTOP_SIZES)(SLOT_VALUE).srcSet}
      />
      <SkeletonImg
        slot="cover"
        sizes={COVER_SIZES}
        sources={fluidSizesSources(COVER_SIZES, 16 / 9)}
        className="img-force-full"
      />
    </picture>
  );

  return (
    <div className="BundlePageSkeleton">
      <SkeletonBundleLayout pills cover={cover} />
    </div>
  );
}
